module.exports = "<input class=\"input\"\r\ntype=\"text\"\r\n[(ngModel)]=\"autocompleteInput\"\r\n#addresstext style=\"padding: 12px 20px; border: 1px solid #ccc; width: 400px\"\r\n>"


//////////////////
// WEBPACK FOOTER
// ./src/app/google/google.component.html
// module id = ./src/app/google/google.component.html
// module chunks = main